import { makeStyles } from '@material-ui/core';
import styled, { css } from 'styled-components';
import palette from 'theme/palette';
import {
	fullInsuranceSVG,
	unlimitedKmSVG,
	deliverySVG,
	driverSVG,
} from 'assets/images/icons/additionalServices';

export const useStyles = makeStyles((theme) => ({
	root: {
		color: 'inherit',
		textDecoration: 'none',
		height: '100%',
	},
	wrapper: {
		height: '100%',
		[theme.breakpoints.down('sm')]: {
			borderRadius: 12,
		},
	},
	carImage: {
		width: '100%',
		height: 'auto',
	},
	officeImage: {
		maxWidth: '100%',
		maxHeight: '30px',
		height: 'auto',
		width: 'auto',
	},
	carName: {
		lineHeight: '1.1em',
		minHeight: '2.2em',
	},
	image: {
		width: '35px',
		height: '35px',
	},
	mobileOfficeWrapper: {
		maxWidth: 100,
		maxHeight: 100,
		aspectRatio: 1 / 1,
		margin: theme.spacing(2),
		border: `1px solid ${theme.palette.divider}`,
		borderRadius: 20,
	},
	starIcon: {
		color: '#f8cf74',
	},
	carImg: {
		objectFit: 'contain',
		width: '100%',
	},
	carInfoWrapper: {
		flexBasis: '70%',
		maxWidth: '100%',
	},
}));

const IconCss = css`
	height: 35px;
	width: 35px;

	g {
		fill: ${palette.secondary.main};
	}
`;

export const UnlimitedKmIcon = styled(unlimitedKmSVG)`
	${IconCss};
`;
export const FullInsuranceIcon = styled(fullInsuranceSVG)`
	${IconCss};
`;
export const DeliveryIcon = styled(deliverySVG)`
	${IconCss};
`;
export const DriverIcon = styled(driverSVG)`
	${IconCss};
`;
